import React, { FC } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { Header, Body, Typography, Footer } from "../styled";
import { format } from "date-fns";

const Holiday: FC = () => {
    return (
        <Box mt={1}>
            <Header mb={2}>
                <Box display={'flex'}>
                    <Typography mb={1} ml={3}>Дата назначения</Typography>
                    <Typography mb={1} ml={17}>Отделение</Typography>
                    <Typography mb={1} ml={29}>Должность</Typography>
                    <Typography mb={1} ml={18}>Ставка</Typography>
                    <Typography mb={1} ml={9}>Вид работы</Typography>
                    <Typography mb={1} ml={8}>Дата перемещения</Typography>
                    <Typography mb={1} ml={3}>0-ОМС <br />1-хозрасчет 2-бюджет</Typography>
                </Box>
                <Box display='flex'>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "300px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "300px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "100px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "300px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "300px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "100px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "300px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "300px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "100px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "300px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "300px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "100px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "300px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "300px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "100px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "300px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "300px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "100px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "300px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "300px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "100px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "300px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "300px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "100px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
            </Header>
            <Body>
                <Box display={'flex'}>
                    <Typography mb={1} ml={32}>Вид отпуска</Typography>
                    <Typography mb={1} ml={37}>Дата начала</Typography>
                    <Typography mb={1} ml={10}>Дата окончания</Typography>
                    <Typography mb={1} ml={4}>Количество дней отпуска</Typography>
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mr: 1, mb: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mr: 1, mb: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mr: 1, mb: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mr: 1, mb: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mr: 1, mb: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mr: 1, mb: 1 }}
                    />
                </Box>
            </Body>
            <Footer>
                <Box display="flex" alignItems="center">
                    <Typography mr={6}>Вид отпуска</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mr: 1 }}
                    />
                </Box>
                <Box display='flex' alignItems={'center'} mt={1}>
                    <Typography mr={6.8}>№ приказа</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mb: 1}}
                    />
                    <Typography mr={1} ml={1}>&</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "100px", mb: 1}}
                    />
                    <Typography mr={1} ml={1}>Дата приказа</Typography>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mb: 1}}
                    />
                </Box>
                <Box display='flex' alignItems={'center'}>
                    <Typography mr={6.8}>№ приказа</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mb: 1}}
                    />
                    <Typography mr={1} ml={1}>&</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "100px", mb: 1}}
                    />
                    <Typography mr={1} ml={1}>Дата приказа</Typography>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mb: 1}}
                    />
                    <Typography mr={1} ml={1}>(для декретного отпуска)</Typography>
                </Box>
                <Box display='flex' alignItems={'center'}>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mb: 1, ml: 17}}
                    />
                </Box>

                <Box display='flex' alignItems={'center'}>
                    <Typography mr={1.2}>Период работы с</Typography>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mb: 1}}
                    />
                    <Typography mr={1} ml={1}>По</Typography>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mb: 1}}
                    />
                    <Typography mr={1} ml={1}>Основной отпуск с </Typography>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mb: 1, ml: 6.3}}
                    />
                    <Typography mr={1} ml={1}>по</Typography>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mb: 1}}
                    />
                    <Typography mr={1} ml={1}>календарные дни</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "100px", mb: 1}}
                    />
                </Box>
                <Box display='flex' alignItems={'center'}>
                    <Typography mr={1.2}>Период работы с</Typography>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mb: 1}}
                    />
                    <Typography mr={1} ml={1}>По</Typography>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mb: 1}}
                    />
                    <Typography mr={1} ml={1}>дополнительный отпуск с </Typography>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mb: 1}}
                    />
                    <Typography mr={1} ml={1}>по</Typography>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mb: 1}}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "100px", mb: 1, ml: 18.2}}
                    />
                </Box>
                <Box display='flex' alignItems={'center'}>
                    <Typography mr={1} ml={65.1}>Итого дней отпуска с</Typography>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mb: 1, ml: 4.2}}
                    />
                    <Typography mr={1} ml={1}>по</Typography>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{width: "170px", mb: 1}}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "100px", mb: 1, ml: 18.2}}
                    />
                </Box>
            </Footer>
        </Box>
    );
};

export default Holiday;

